/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './Documents.scss';
import { loadDocuments } from 'actions/building';
import { DOCUMENT_BASE_URL } from 'constants/Config';
import { withTranslation } from 'react-i18next';
import { trackGA, gaEvent } from 'services/ga';
import { withRouter } from 'react-router-dom';
const icons = {
  pdf: require('assets/images/icons/icon-pdf.svg'),
  doc: require('assets/images/icons/icon-doc.svg'),
  docx: require('assets/images/icons/icon-doc.svg'),
  xls: require('assets/images/icons/icon-xls.svg'),
  xlsx: require('assets/images/icons/icon-xls.svg'),
  txt: require('assets/images/icons/icon-txt.svg'),
  png: require('assets/images/icons/icon-png.svg'),
  jpg: require('assets/images/icons/icon-jpg.svg'),
  jpeg: require('assets/images/icons/icon-jpg.svg'),
};

const extension = /\.([0-9a-z]+)$/i;

const getExtensionIcon = (path) => {
  const match = path.toLowerCase().match(extension);
  const ext = match ? match[1] : null;
  return icons[ext] || require('assets/images/icons/icon-doc.svg');
};

class Documents extends Component {
  componentWillMount() {
    if (!this.props.isDocumentsLoading) {
      this.props.loadDocuments(this.props.params.id);
    }
  }

  render() {
    const { className, building, isDocumentsLoading, client, t, profile, location, objectType } =
      this.props;
    const { documents, data } = building;

    return (
      <div className={cn(styles.Documents, className)}>
        {documents && documents.length > 0 ? (
          <div>
            <h3 className={client ? styles.TitleClient : styles.Title}>
              {t('components.building.main.documents.title')}
            </h3>
            <div className={styles.DocumentsList}>
              {documents &&
                documents.map(({ id, path, name }) => (
                  <a
                    className={styles.Document}
                    target="_blank"
                    href={`${DOCUMENT_BASE_URL}/${path}`}
                    key={id}
                    onClick={() =>
                      trackGA(
                        gaEvent.documentClick({
                          screenName: location.pathname,
                          productType: objectType,
                          productName: data.title,
                          productID: data.id,
                          user_id: profile.id,
                        })
                      )
                    }
                  >
                    <span className={styles.DocumentIcon}>
                      <img src={getExtensionIcon(path)} alt="" />
                    </span>
                    {name}
                  </a>
                ))}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      (state) => ({
        isDocumentsLoading: state.building.isDocumentsLoading,
        profile: state.profile,
      }),
      { loadDocuments }
    )(Documents)
  )
);



// WEBPACK FOOTER //
// ./src/components/Building/Main/Documents/Documents.js